const LOGOS = [
  { src: "/images/certs/caq-sports.png", alt: "American Board of Family Medicine" },
  { src: "/images/certs/aoasm.png", alt: "American Osteopathic Academy of Sports Medicine" },
  { src: "/images/certs/abfm.png", alt: "St. Luke's University Health Network" },
  { src: "/images/certs/aoa.png", alt: "American Osteopathic Association" },
  { src: "/images/certs/tobi.png", alt: "TOBI, The Orthobiologic Institute" },
  { src: "/images/certs/sju.png", alt: "Saint Joseph's University" },
  { src: "/images/certs/muhlenberg.png", alt: "Muhlenberg College" },
  { src: "/images/certs/suburban.jpg", alt: "Suburban Hospital, Johns Hopkins Medicine" },
  { src: "/images/certs/biocellerator.png", alt: "BioXcellerator" },
];

export const CertMarquee = () => (
  <div data-testid="cert-marquee" className="mt-14 border-y border-[var(--brand-gold-soft)] bg-white py-8 overflow-hidden">
    <p className="text-center text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)] mb-6">
      Education, training &amp; certifications
    </p>
    <div className="marquee" aria-label="Education, training, and certification organizations">
      <div className="marquee-track">
        {[...LOGOS, ...LOGOS].map((l, i) => (
          <img
            key={`${l.src}-${i}`}
            src={l.src}
            alt={i < LOGOS.length ? l.alt : ""}
            aria-hidden={i >= LOGOS.length}
            loading="lazy"
            className="h-12 sm:h-14 w-auto object-contain shrink-0 opacity-80"
          />
        ))}
      </div>
    </div>
  </div>
);
